import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const About = () => {
  return (
    <div className="min-h-screen bg-black">
      {/* Header */}
      <div className="bg-gradient-to-r from-yellow-600 to-yellow-400 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-black mb-4">About Us</h1>
          <p className="text-xl text-gray-900">Experience sports like never before</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <div className="inline-block h-1 w-20 bg-yellow-400 mb-6"></div>
            <h2 className="text-4xl font-bold text-white mb-6">Who We Are</h2>
            <div className="space-y-4 text-gray-300 text-lg">
              <p>
                The Sport Bloc is Shillong's premier sports facility provider, dedicated to bringing 
                world-class sporting experiences to the community. We operate multiple state-of-the-art 
                venues across the city, each designed with passion and precision.
              </p>
              <p>
                From our Football Arena featuring top-quality futsal turfs to our Racquet Sports Arena 
                with professional-grade pickleball courts, we provide facilities that cater to athletes 
                of all skill levels.
              </p>
              <p>
                At The Sport Bloc, we believe sports should be accessible, enjoyable, and played in 
                the best possible environment. Our facilities are climate-controlled, well-maintained, 
                and equipped with modern amenities to ensure you have the best experience every time you visit.
              </p>
            </div>
          </div>

          <div className="relative h-96 rounded-2xl overflow-hidden">
            <img
              src="/images/football-arena.jpg"
              alt="The Sport Bloc — Football Arena"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Our Values */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <div className="inline-block h-1 w-20 bg-yellow-400 mb-6"></div>
            <h2 className="text-4xl font-bold text-white">Our Values</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Card className="bg-gray-900 border-yellow-500/20">
              <CardContent className="p-8 text-center">
                <div className="text-5xl mb-4">🏆</div>
                <h3 className="text-xl font-bold text-yellow-400 mb-3">Excellence</h3>
                <p className="text-gray-400">
                  We maintain the highest standards in facilities, equipment, and service.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-gray-900 border-yellow-500/20">
              <CardContent className="p-8 text-center">
                <div className="text-5xl mb-4">🤝</div>
                <h3 className="text-xl font-bold text-yellow-400 mb-3">Community</h3>
                <p className="text-gray-400">
                  Building a vibrant sports community where everyone is welcome.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-gray-900 border-yellow-500/20">
              <CardContent className="p-8 text-center">
                <div className="text-5xl mb-4">✨</div>
                <h3 className="text-xl font-bold text-yellow-400 mb-3">Innovation</h3>
                <p className="text-gray-400">
                  Continuously improving our facilities and services with the latest technology.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Why Choose Us */}
        <div>
          <div className="text-center mb-12">
            <div className="inline-block h-1 w-20 bg-yellow-400 mb-6"></div>
            <h2 className="text-4xl font-bold text-white">Why Choose Us</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              'State-of-the-art facilities with climate control',
              'Professional-grade equipment and surfaces',
              'Convenient online booking system',
              'Experienced and friendly staff',
              'Ample parking and modern amenities',
              'In-house cafe and sports store',
              'Clean and well-maintained facilities',
              'Competitive pricing with flexible hours'
            ].map((point, idx) => (
              <div key={idx} className="flex items-start">
                <CheckCircle className="w-6 h-6 text-yellow-400 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-lg">{point}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;